<template>
  <div>
    <v-card class="card-user-historic">
      <v-card-title
        v-if="user"
        class="user-name"
        primary-title
        :style="`background-color: ${user.color}; color: #000000;
      font-weight: 700;`"
      >
        {{ user.fullname }}
        <a target="_blank" :href="Links.DawanOrgShowPerson(user.personSlug)">
          (Fiche DG2)
        </a>
      </v-card-title>
      <v-expansion-panels
        multiple
        v-if="user.historic"
        accordion
        class="scroll-y"
      >
        <v-expansion-panel v-if="user.historic.followed.length > 0">
          <v-expansion-panel-header>{{
            $t("userHistoric.folowed")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              v-for="training in user.historic.followed"
              :key="parseTrainingSlug(training)"
            >
              <a
                target="_blank"
                :href="
                  Links.DawanOrgShowTrainingSession(parseTrainingSlug(training))
                "
              >
                <p>
                  {{ training.title }} - {{ training.duration }}
                  {{ $t("userHistoric.shortDay") }}
                </p>
              </a>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="user.historic.animated.length > 0">
          <v-expansion-panel-header>{{
            $t("userHistoric.animated")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              v-for="training in user.historic.animated"
              :key="training.slug"
            >
              <p>
                {{ training.title }} - {{ training.duration }}
                {{ $t("userHistoric.shortDay") }}
              </p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="user.historic.preparationCalls.length > 0">
          <v-expansion-panel-header>
            {{ $t("userHistoric.preparationCalls") }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              v-for="preparation in user.historic.preparationCalls"
              :key="preparation.slug"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  #{{ preparation.preparationCallId }} -
                  {{
                    courses.find((c) => c.idDg2 == preparation.trainingId).title
                  }}
                </v-expansion-panel-header>

                <v-expansion-panel-content
                  ><p>{{ preparation.replyChain }}</p>
                  <a
                    :href="Links.DawanOrgShowPreparationCall(preparation.slug)"
                    target="_blank"
                    >{{ $t("userHistoric.link") }}</a
                  >
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-text v-else>
        <v-progress-circular
          size="50"
          width="5"
          indeterminate
          color="dark"
        ></v-progress-circular>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DateTime } from "luxon";
import Links from "@/models/Links";

export default {
  name: "dialog-user-animated-folowed-traynings",
  props: {
    userIdDg2: null,
  },
  data() {
    return {
      spiner: true,
      Links: Links,
    };
  },
  computed: {
    ...mapGetters("userModule", {
      getOne: "getOne",
    }),
    ...mapGetters("courseModule", {
      courses: "getCourses",
    }),
    user() {
      return this.getOne(this.userIdDg2);
    },
  },
  mounted() {
    this.fetchUserHistoric();
  },
  watch: {
    user() {
      this.fetchUserHistoric();
    },
  },
  methods: {
    ...mapActions("userModule", ["setHistoricOnUser"]),

    parseTrainingSlug(training) {
      let slug = training.trainingSlug + "-";
      let date = "";
      if (training.beginAt) {
        date = training.beginAt.slice(0, training.beginAt.length - 15);
      }
      date = DateTime.fromISO(date).toFormat("dd-MM-yyyy");
      return slug + date;
    },
    fetchUserHistoric() {
      if (!this.user.historic) {
        this.setHistoricOnUser({
          userIdDg2: this.userIdDg2,
        });
        this.spiner = false;
      }
    },
  },
};
</script>

<style lang="scss">
.card-user-historic {
  a {
    text-decoration: underline;
    color: rgb(0, 89, 255);
  }
}
</style>
